'use client'

import * as echarts from 'echarts'
import { ECBasicOption } from 'echarts/types/src/util/types.js'
import { useEffect, useRef } from 'react'

export default function Charts({
  children,
  className,
  options,
}: {
  children?: React.ReactNode
  className?: string
  options: ECBasicOption
}) {
  const selfRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const el = selfRef.current
    if (!el) {
      return
    }

    const myChart = echarts.init(el)
    myChart.setOption(options)

    function handleResize() {
      myChart.resize()
    }
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      myChart.dispose()
    }
  }, [options])

  return (
    <div className={className} ref={selfRef}>
      {children}
    </div>
  )
}
